import { userRole, userType } from '@/helpers/enum';
export default {
  activeMenuItem: state => state.sideNav.activeItem,
  currentPageTitle: (state) => {
    const breadcrumbs = state.breadcrumbs.data;
    return breadcrumbs.length && breadcrumbs[breadcrumbs.length - 1].text;
  },
  fullName: state => (state.userInfo || {}).fullName,
  firstName: state => ((state.userInfo || {}).fullName ? (state.userInfo || {}).fullName.split(' ')[0] || '' : ''),
  lastName: state => ((state.userInfo || {}).fullName ? (state.userInfo || {}).fullName.split(' ')[1] || '' : ''),
  socialId: state => (state.userInfo || {}).socialId, // in-case of user type is organization socialId will be national number
  commercialRegistrationNumber: state => (state.userInfo || {}).commercialRecordNumber,
  unifiedNumber: state => (state.userInfo || {}).nationalRecordNumber,
  impersonatedBySocialId: state => (state.userInfo || {}).impersonatedBySocialId,
  isOrganization: state => (state.userInfo || {}).userType == userType.najizOrganization,
  isMohPartner: state => (state.userInfo || {}).userType == userType.healthAffairs,
  isPortalPartner: state => (state.userInfo || {}).userType == userType.najizServicesCenter || (state.userInfo || {}).userType == userType.healthAffairs || (state.userInfo || {}).userType == userType.MOHComplianceManagement,
  getRouteName: state => (id) => {
    let childMenuItems = [];
    const parentItem = state.sideNav.data.find((item) => {
      childMenuItems = childMenuItems.concat(item.childMenuItems);
      return item.id === id;
    });
    if (!parentItem) {
      const childItem = childMenuItems.find(item => item.id === id);
      if (!childItem) return '';
      return childItem.name;
    }
    return parentItem.name;
  },
  finalRoutes: state => getChildIfExists(state.sideNav.data),
  isAutoSearch: state => !!(state.sideNav.activeItem.properties || {}).autoSearch,
  isUserHasAnyCentralAuditRole: (state) => {
    if (!state.userInfo || !state.userInfo.userPositions) return false;
    const { centralAuditHead, centralAuditSupervisor, centralAuditEmployee } = userRole;
    const centralAuditRoles = [centralAuditHead, centralAuditSupervisor, centralAuditEmployee];
    return !!state.userInfo.userPositions.find(
      position => centralAuditRoles.indexOf(position.roleId) !== -1
    );
  },
  isUserHasAnyServicesCenterRole: (state) => {
    if (!state.userInfo || !state.userInfo.userPositions) return false;
    const servicesCenterRoles = [
      userRole.servicesCenterSupervisor,
      userRole.servicesCenterAuditEmployee,
      userRole.servicesCenterConsultant,
    ];
    return !!state.userInfo.userPositions.find(
      position => servicesCenterRoles.indexOf(position.roleId) !== -1
    );
  },
};

const getChildIfExists = (nodes) => {
  const finalNodes = [];
  (nodes || []).forEach((node) => {
    if (node.route) {
      finalNodes.push(node);
    }
    finalNodes.push(...getChildIfExists(node.childMenuItems));
  });
  return finalNodes;
};
